import React from 'react';
import { CreditCardOutlined } from '@ant-design/icons';
import AppIconGroup from '../../../components/app-icon-group';
import SwitchShop from '../../shop/switch-shop';
import CouponList from './list';

const iconStyle = {
    fontSize: 28,
}

export default () => {
  return (
    <div>
        <SwitchShop />
        
        {/* 快捷操作 - iOS 风格图标组 */}
        <div className="mt-3 mb-4">
            <AppIconGroup 
                items={[
                    {
                        id: 1,
                        href: '/promotion/coupon/create',
                        title: '创建优惠券',
                        icon: <CreditCardOutlined />,
                        color: 'from-blue-500 to-blue-600'
                    }
                ]}
                cols="3-3-3-3-3"
            />
        </div>
        
        <h2 className="admin-page-title">优惠券模版列表</h2>
        <CouponList />
    </div>
  )
}